import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getProfile, updateImage, profileUpdate } from "../store/Admin/admin.action";
import { setToast } from "../util/toast";
import { PageHead } from "./Panel/kit";

// Admin profili: bilgiler, fotograf, sifre — tek sayfada, sade.
const ROLE = { owner: "Sahip", manager: "Super Admin", agency_rep: "Ajans sorumlusu", moderator: "Moderatör", finance: "Finans" };

const Proflie = () => {
  const admin = useSelector((state) => state.admin.admin);
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [preview, setPreview] = useState("");
  const [file, setFile] = useState(null);
  const [pass, setPass] = useState({ oldPass: "", newPass: "", confirmPass: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    setName(admin?.name || "");
    setEmail(admin?.email || "");
    setPreview(admin?.image || "");
  }, [admin]);

  const pickImage = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const saveImage = () => {
    const fd = new FormData();
    fd.append("image", file);
    dispatch(updateImage(fd));
    setFile(null);
  };

  const saveInfo = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) return setToast("error", "Ad ve e-posta gerekli");
    dispatch(profileUpdate({ name: name.trim(), email: email.trim() }));
  };

  const savePassword = async (e) => {
    e.preventDefault();
    if (!pass.oldPass || !pass.newPass) return setToast("error", "Mevcut ve yeni şifreyi gir");
    if (pass.newPass.length < 8) return setToast("error", "Yeni şifre en az 8 karakter olmalı");
    if (pass.newPass !== pass.confirmPass) return setToast("error", "Yeni şifreler aynı değil");
    setBusy(true);
    try {
      const { data } = await axios.put("admin/updatePassword", pass);
      if (!data?.status) return setToast("error", data?.message || "Şifre değiştirilemedi");
      setToast("success", "Şifre değişti, yeniden giriş yap");
      setTimeout(() => {
        sessionStorage.clear();
        window.location.href = "/";
      }, 1500);
    } catch (err) {
      setToast("error", "Şifre değiştirilemedi");
    } finally {
      setBusy(false);
    }
  };

  const initials = (admin?.name || "A").trim().slice(0, 1).toUpperCase();

  return (
    <div className="badu-profile">
      <PageHead title="Profilim" sub="Yönetici bilgilerin, fotoğrafın ve şifren" />

      <div className="badu-profile-grid">
        <div className="card badu-profile-card">
          <div className="card-body">
            <label className="badu-avatar-xl" title="Fotoğrafı değiştir">
              {preview ? <img src={preview} alt="" onError={(e) => (e.currentTarget.style.display = "none")} /> : null}
              <b>{initials}</b>
              <input type="file" accept="image/*" hidden onChange={pickImage} />
              <span className="badu-avatar-edit">Değiştir</span>
            </label>
            <h5>{admin?.name || "Admin"}</h5>
            <p className="badu-muted">{admin?.email}</p>
            <span className="badu-chip info">{ROLE[admin?.role || "owner"] || "Yönetici"}</span>
            {file && (
              <button className="btn btn-primary btn-block mt-3" onClick={saveImage}>
                Fotoğrafı kaydet
              </button>
            )}
          </div>
        </div>

        <div className="badu-profile-forms">
          <form className="card" onSubmit={saveInfo}>
            <div className="card-body">
              <h6 className="badu-card-title">Bilgiler</h6>
              <div className="badu-form-row">
                <div>
                  <label className="badu-label">Ad</label>
                  <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div>
                  <label className="badu-label">E-posta</label>
                  <input className="form-control" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
              </div>
              <div className="badu-form-actions">
                <span />
                <button className="btn btn-primary" type="submit">Kaydet</button>
              </div>
            </div>
          </form>

          <form className="card" onSubmit={savePassword}>
            <div className="card-body">
              <h6 className="badu-card-title">Şifre değiştir</h6>
              <div className="badu-form-row three">
                <div>
                  <label className="badu-label">Mevcut şifre</label>
                  <input className="form-control" type="password" autoComplete="current-password" value={pass.oldPass} onChange={(e) => setPass({ ...pass, oldPass: e.target.value })} />
                </div>
                <div>
                  <label className="badu-label">Yeni şifre</label>
                  <input className="form-control" type="password" autoComplete="new-password" value={pass.newPass} onChange={(e) => setPass({ ...pass, newPass: e.target.value })} />
                </div>
                <div>
                  <label className="badu-label">Yeni şifre (tekrar)</label>
                  <input className="form-control" type="password" autoComplete="new-password" value={pass.confirmPass} onChange={(e) => setPass({ ...pass, confirmPass: e.target.value })} />
                </div>
              </div>
              <div className="badu-form-actions">
                <span className="badu-muted">Değiştirince yeniden giriş yapman gerekir.</span>
                <button className="btn btn-dark" type="submit" disabled={busy}>
                  {busy ? "Değiştiriliyor…" : "Şifreyi değiştir"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Proflie;
